import { Component, OnInit, Input, Output, EventEmitter, ViewChildren } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { AddlocalityComponent } from '../../locality/addlocality/addlocality.component';
@Component({
  selector: 'app-addparty',
  templateUrl: './addparty.component.html',
  styleUrls: ['./addparty.component.css']
})
export class AddpartyComponent implements OnInit {
  @ViewChildren('inputfirst') firstipcontrol;

  //Mode Values
  //terms Values
  isaddterms: boolean = false;
  iseditterms: boolean = false;
  isdeleteterms: boolean = false;
  isviewterms: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = " ";

  islocalityaddmode: boolean = false;
  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  localityColl: any = [];
  //Edit Get Values
  partyColl: any = [];

  ptype: String = "";

  partyform = new FormGroup({
    partyid: new FormControl(null),
    partyname: new FormControl('', Validators.required),
    othername: new FormControl(''),
    mobileno: new FormControl(''),
    address1: new FormControl(''),
    address2: new FormControl(''),
    address3: new FormControl(''),
    landmark: new FormControl(''),
    localityid: new FormControl(null),
    ptype: new FormControl(''),
    taxno: new FormControl(''),
    inactive: new FormControl(false),
  });


  @Input() partyid: number = 0;
  @Input() partyname: any = '';
  @Output() emitData = new EventEmitter();


  constructor(private toastr: ToastrService, private appService: DhukanDataService, private route: ActivatedRoute, private productFindService: NgbModal,
    private loginService: LoginDataService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.partyid = params.id
      }
    });
    this.fnServiceChanges();
  }


  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {

          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }

        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    });
  }
  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {
          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnGetUserRoleList();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  ngAfterViewInit() {
    //this.firstipcontrol.first.nativeElement.focus();
  }

  fnOnInitForm() {
    try {
      this.isaddterms = true;
      this.partyform.reset();
      this.fnInitializePartyFormGroup();

      if (this.partyid > 0) {
        this.fngetParty();
      }
      this.fngetLocality();

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }


  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.partyid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }
    this.islocalityaddmode = this.loginService.fnCheckUserRoleAction("Locality", 'CREATE')
    return _check;
  }
  fnUserFailedForm() {
    this.isprivilage = true;
  }




  fnInitializePartyFormGroup() {
    this.partyform.setValue({
      partyid: 0,
      partyname: '',
      othername: '',
      mobileno: '',
      address1: '',
      address2: '',
      address3: '',
      landmark: '',
      localityid: null,
      ptype: this.ptype,
      taxno: '',
      inactive: false,
    })
  }

  //Get 
  fngetLocality() {
    var data = {
      'localityid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getLocality(data)
      .subscribe(
        (res) => {
          //console.log(res)
          this.localityColl = res.json().result;

        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  //Get 
  fngetParty() {

    var data = {
      'partyid': this.partyid,
      'ptype': this.ptype,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getParty(data)
      .subscribe(
        (res) => {
          this.partyColl = res.json().result;
          var editdata = this.partyColl[0];

          this.fnEditterms(editdata);
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }




  //Save Btn Click
  fnSaveBtnClick() {
    try {
      if (this.saveloading) {
        return;
      }

      this.submitted = true;
      this.successfully = false;

      //Validate
      if (this.partyform.valid) {
        this.saveloading = true;
        //Check
        var data = {
          'partyid': this.partyid,
          'partyname': this.partyform.get('partyname').value,
          'othername': this.partyform.get('othername').value,
          'mobileno': this.partyform.get('mobileno').value,
          'address1': this.partyform.get('address1').value,
          'address2': this.partyform.get('address2').value,
          'address3': this.partyform.get('address3').value,
          'landmark': this.partyform.get('landmark').value,
          'localityid': this.partyform.get('localityid').value,
          'ptype': this.partyform.get('ptype').value,
          'taxno': this.partyform.get('taxno').value,
          'inactive': this.partyform.get('inactive').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }

        this.appService.fnCheckParty(data).subscribe(
          (res) => {
            var _checkresult = res.json().result[0].checkfield;
            //console.log(_checkresult)
            if (_checkresult === "done") {
              if (this.partyform.get('partyid').value > 0) {
                //Update Department
                this.fnSetParty(data);
              }
              else {
                //Insert Department
                this.fnInsertParty(data);
              }
            }
            else {
              if (_checkresult === "name") {
                this.saveloading = false;
                this.partyform.controls['mobileno'].setErrors({ 'notfound': true });
              }
            }
          },
          (err) => {
            this.saveloading = false;
            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading = false;
      this.fnShowErrorMsg(ex);
    }
  }



  //Insert
  fnInsertParty(data) {

    this.appService.fnInsertParty(data).subscribe(
      (res) => {
        this.saveloading = false;
        if (res.json().status === 200) {

          var result = res.json().result;

          var partyid = 0;
          if (result.length > 0) {
            partyid = result[0].partyid
          }

          if (this.ptype === 'C') {
            this.toastr.success('', "The New Customer has been added successfully.Insert Successfully");
          }
          else if (this.ptype === 'S') {
            this.toastr.success('', "The New Supplier has been added successfully.Insert Successfully");
          }

          this.emitData.emit(partyid);
          this.activeModal.close(true);

        }
      },
      (err) => {
        this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }
  //Set
  fnSetParty(data) {

    this.appService.fnSetParty(data).subscribe(
      (res) => {
        this.saveloading = false;
        if (res.json().result != "") {
          if (this.ptype === 'C') {
            this.toastr.success('', "The Customer has been updated successfully.");
          }
          else if (this.ptype === 'S') {
            this.toastr.success('', "The Supplier has been updated successfully.");
          }


          this.fnInsertActivityLog('EDIT', this.partyid, data.partyname);

          this.emitData.emit(this.partyid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }
  private fnEditterms(deptBO) {

    this.partyform.setValue({
      partyid: deptBO.partyid,
      partyname: deptBO.partyname,
      othername: deptBO.othername,
      mobileno: deptBO.mobileno,
      address1: deptBO.address1,
      address2: deptBO.address2,
      address3: deptBO.address3,
      landmark: deptBO.landmark,
      localityid: deptBO.localityid,
      ptype: deptBO.ptype,
      taxno: deptBO.taxno,
      inactive: deptBO.inactive,
    });

    this.isaddterms = false;
    this.iseditterms = true;
    this.isdeleteterms = false;
    this.isviewterms = false;
  }
  // fnSetCountryState(){

  //  var  _country='';
  //  var  _state='';
  //   for(let row of this.companyColl){
  //    _country=row.country
  //    _state=row.state
  //     }

  // this.partyform.patchValue({'country':_country})
  // this.fngetState();
  //    this.partyform.patchValue({'state':_state})
  //   }



  //AddUom
  private fnAddLocality() {

    const modalRef = this.productFindService.open(AddlocalityComponent, { size: <any>'m' });
    modalRef.componentInstance.localityColl = this.localityColl
    modalRef.componentInstance.localityid = this.partyform.get('localityid').value

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fngetLocality();

      if (receivedEntry > 0) {
        this.partyform.patchValue({ localityid: receivedEntry })
      }
    });

  }


  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }

  public decline() {
    this.activeModal.close(false);
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }

}
